import React from 'react';
import { ArrowRight, Globe } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';

export const HeroSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-[#508f9d]/5 to-[#8b2e4a]/5"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#508f9d]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#c2983e]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-[#508f9d]/10 px-4 py-2 rounded-full">
              <Globe className="w-4 h-4 text-[#508f9d]" />
              <span className="text-sm font-medium text-[#0f3f5d]">Cross-Border Advisory Excellence</span>
            </div>

            <h1 className="text-4xl lg:text-5xl font-bold text-[#0f3f5d] leading-tight">
              JCAN Resources LLC<br />
              Bridging Borders, Building Partnerships
            </h1>

            <p className="text-xl text-gray-700 leading-relaxed">
              {heroData.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                size="lg"
                className="bg-[#8b2e4a] hover:bg-[#6d2339] text-white text-lg px-8 py-6 group"
              >
                {heroData.cta.primary}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={() => scrollToSection('services')}
                size="lg"
                variant="outline"
                className="border-2 border-[#508f9d] text-[#508f9d] hover:bg-[#508f9d] hover:text-white text-lg px-8 py-6"
              >
                {heroData.cta.secondary}
              </Button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <p className="text-3xl font-bold text-[#8b2e4a]">15+</p>
                <p className="text-sm text-gray-600">Years Experience</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-[#8b2e4a]">25+</p>
                <p className="text-sm text-gray-600">Markets Served</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-[#8b2e4a]">$500M+</p>
                <p className="text-sm text-gray-600">Capital Facilitated</p>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80" 
                alt="Global connectivity" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#8b2e4a]/60 via-transparent to-[#508f9d]/40"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-xl border-l-4 border-[#c2983e]">
              <p className="text-sm text-gray-600 mb-1">Client Success Rate</p>
              <p className="text-3xl font-bold text-[#8b2e4a]">100%</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
